import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';

import CustomButton from '../../designSystem/Button';
import { handleExportGenericPDF } from './banks/0';
import { handleExportBancoDeChileXLSX } from './banks/1';
import { handleExportBICECsv } from './banks/28';
import { handleExportSantanderXLSX } from './banks/37';
import { handleExportItauTxt } from './banks/39';

interface AvailableBanks {
  id: number;
  name: string;
  export: (payments: any, id: any, message?: string) => Promise<void>;
}

const availableBanks: AvailableBanks[] = [
  { id: 0, name: 'PDF Genérico', export: handleExportGenericPDF },
  { id: 1, name: 'Banco de Chile', export: handleExportBancoDeChileXLSX },
  { id: 28, name: 'Banco BICE', export: handleExportBICECsv },
  { id: 37, name: 'Banco Santander', export: handleExportSantanderXLSX },
  { id: 39, name: 'Banco Itaú', export: handleExportItauTxt },
];

const NomineeExporter = (props: any) => {
  const { payments, open, setOpen, id } = props;
  const [message, setMessage] = useState(`Operación ${id}`);
  const [bankCode, setBankCode] = useState(0);
  if (open === false) return null;

  const handleExport = (m: string) => {
    const bank = availableBanks.find((x) => x.id === bankCode);
    if (bank) {
      bank.export(payments, id, m);
    }
  };

  const handleClose = () => {
    if (setOpen) setOpen(false);
  };
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>Exportar</DialogTitle>
        <DialogContent>
          <Typography variant="body1" gutterBottom>
            Estos son los bancos disponibles para exportar nóminas.
          </Typography>
          <FormControl
            variant="outlined"
            fullWidth
            style={{ marginBottom: '10px' }}
          >
            <InputLabel id="bank">Banco</InputLabel>
            <Select
              labelId="filter-label"
              id="Filtrar por estado"
              fullWidth
              value={bankCode}
              onChange={(e) => setBankCode(e.target.value as number)}
              label="Banco"
            >
              {availableBanks.map((bank) => (
                <MenuItem key={bank.id} value={bank.id}>
                  {bank.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Mensaje en glosa"
            variant="outlined"
            fullWidth
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            style={{ marginBottom: '10px' }}
          />
        </DialogContent>
        <DialogActions>
          <CustomButton color="secondary" onClick={handleClose}>
            Cancelar
          </CustomButton>
          <CustomButton
            onClick={() => handleExport(message)}
            variant="contained"
            color="primary"
            size="small"
          >
            Exportar
          </CustomButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default NomineeExporter;
